// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(128),
    target: z.string().min(1).max(160),
    identityId: z.string().min(1).max(512),
});
const guard = z.object({
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(128),
    target: z.string().min(1).max(160),
    identityId: z.string().min(1).max(512),
});
export const UserFeishuIdentities = Object.freeze({
    table: 'user_feishu_identities',
    tableSingular: 'user_feishu_identity',
    fields: {
        tenantId: 'tenant_id',
        userId: 'user_id',
        target: 'target',
        identityId: 'identity_id',
    },
    fieldKeys: [
        'tenantId',
        'userId',
        'target',
        'identityId',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
